import styled from "styled-components";
import { colors } from "../../../../assets";
import { BodyTextContainer } from "../../../../components/components-text/body-text/body-text-styles";
import { NoteTextContainer } from "../../../../components/components-text/note-text/note-text-styles";

export const DetailPendantSimulationContainer = styled.div`
  display: flex;
  .detail-pendant-simulation-main {
    height: calc(100vh - 117px);
    padding-right: 40px;
  }

  .detail-pendant-simulation-back {
    display: flex;
    justify-content: space-between;
    margin-bottom: 17px;
  }
  .detail-pendant-simulation-buttons-item {
    min-width: 200px;
    margin-bottom: 16px;
    margin-left: 40px;
  }

  .detail-pendant-simulation-special {
    padding: 40px;
    margin-bottom: 24px;
    background: ${colors["detail-item-background"]};
    border-radius: 3px;
  }

  .detail-pendant-simulation-special-title {
    color: ${colors["PR-001-100"]};
    border-bottom: 1px solid ${colors["PR-001-100"]};
    padding-bottom: 12px;
    margin-bottom: 24px;
  }

  .detail-pendant-simulation-special-container {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }

  .detail-pendant-simulation-special-item {
    display: flex;
    margin-right: 40px;
  }

  .detail-pendant-simulation-special-subitem {
    margin-right: 40px;

    &:last-child {
      margin-right: 0;
    }
  }

  .detail-pendant-simulation-special-subitem-title {
    text-transform: uppercase;
    color: ${colors["TX-001-30"]};
    margin-bottom: 6px;
  }

  .detail-pendant-simulation-special-subitem-content {
    color: ${colors["TX-001-100"]};
  }

  .detail-pendant-simulation-item-content-table {
    margin-bottom: 55px;
    min-width: 100%;
    max-width: 450px;
    overflow-x: auto;

    .table {
      min-width: 840px;
    }

    &:last-child {
      margin-bottom: 0;
    }

    thead {
      border-bottom: 1px solid ${colors["PR-001-100"]};
    }

    th {
      padding: 15px 15px;
      min-width: 50px;
      max-width: 100px;
      color: ${colors["TX-001-30"]};
      .highlighted {
        color: ${colors["TX-001-50"]};
      }
    }

    td {
      padding: 15px 15px;
      min-width: 50px;
      max-width: 300px;
      
      ${BodyTextContainer} {
        display: inline-block;
        &.highlighted {
          font-weight: 600;
        }
      }
    }

    td > div {
      padding: 8px 0;
    }

    .main-table-row {
      &:first-child {
        td {
          padding-top: 20px;
        }
      }

      &:hover {
        box-shadow: none;
      }
    }
  }

  .detail-pendant-simulation-item-content-advise {
    color: ${colors["TX-001-30"]};
  }

  .detail-pendant-simulation-item-content-capital-text {
    margin-bottom: 50px;

    p {
      color: ${colors["TX-001-50"]};
    }

    span {
      color: ${colors["TX-001-100"]};
      margin-left: 8px;
    }
  }

  .detail-pendant-simulation-container {
    margin-bottom: 40px;
  }

  .detail-pendant-simulation-item {
    padding: 40px;
    margin-bottom: 24px;
    background: ${colors["detail-item-background"]};
    border-radius: 3px;
  }

  .detail-pendant-simulation-item-title {
    color: ${colors["PR-001-100"]};
    padding-bottom: 12px;
    margin-bottom: 24px;
  }

  .detail-pendant-simulation-divider {
    border: 0.5px solid ${colors["PR-001-100"]};
    height: 0;
    width: 100%;
    margin-top: 40px;
  }

  .detail-pendant-simulation-footer {
    padding-top: 37px;
    margin-bottom: 40px;
    color: ${colors["PR-001-100"]};
    padding-left: 40px;
    padding-right: 40px;
    ${NoteTextContainer} {
      line-height: 1.5em;
      margin-bottom: 16px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  outline: none;
`;
